import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../utils/http";

const BaseURL = process.env.REACT_APP_API_URL;
export const fetchAllStatesAction = createAsyncThunk("utils/all_states", async () => {
  try {
    const res = await http.get({
      url: `${BaseURL}/state/find-all`,
    });
    if (res) {
      return res?.payload;
    }
    return res;
  } catch (err) {
    throw new Error();
  }
});
